module.exports = __webpack_public_path__ + "img/6.2235de62.jpg";